import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';
import { TextLabels } from 'ngx-material-intl-tel-input';
import { AuthService } from 'src/app/core/firebase/auth.service';
import AppLauncherElectron from 'src/app/plugins/app-launcher.plugin';
import { isElectron } from 'src/app/shared/utils/platform.utils';

export interface SopoPhoneNumberInputData {
    header?: string,
    body?: string,
    cancelText?: string,
    okText?: string,
    checkNumber?: boolean,
    isInUS?: boolean,
}

@Component({
    selector: 'app-sopo-phone-number-input',
    templateUrl: './sopo-phone-number-input.component.html',
    styleUrls: ['./sopo-phone-number-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SopoPhoneNumberInputComponent implements OnInit {
    header: string = '';
    body: string = '';
    cancelText: string = '';
    okText: string = '';
    phoneForm: FormGroup;

    public errorInvalid = false;
    public checkNumber = false;
    public isInUS = false;

    phoneInputError: boolean = false;
    phoneControl: FormControl;
    textLabels: TextLabels = {
        mainLabel: '',
        codePlaceholder: '',
        searchPlaceholderLabel: 'Search',
        noEntriesFoundLabel: '',
        nationalNumberLabel: '',
        hintLabel: '',
        invalidNumberError: '',
        requiredError: ''
    }

    constructor(
        private sopoDialogRef: SopoDialogRef,
        @Inject(SOPO_DIALOG_DATA) data: SopoPhoneNumberInputData,
        private ref: ChangeDetectorRef,
        private authService: AuthService,
    ) {
        if (data.header) this.header = data.header;
        if (data.body) this.body = data.body;
        if (data.cancelText) this.cancelText = data.cancelText;
        if (data.okText) this.okText = data.okText;
        if (data.checkNumber) this.checkNumber = data.checkNumber;
        if (data.isInUS) this.isInUS = data.isInUS;
    }

    ngOnInit(): void {
        this.phoneControl = new FormControl('', [Validators.required])
        this.phoneForm = new FormGroup({
            phone: this.phoneControl,
        });
    }

    public async submitPhone(): Promise<void> {
        if (this.phoneForm.status === 'VALID') {
            this.errorInvalid = false;
            this.sopoDialogRef.close(this.phoneForm.value?.phone);
            return;
        } else {
            this.errorInvalid = true;
        }
        this.ref.detectChanges();
    }

    cancel() {
        this.sopoDialogRef.close();
    }

    openLink(link: string) {
        if (isElectron()) AppLauncherElectron.openUrl({ url: link });
        else window.open(link, '_blank');
    }
}
